import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-reservation',
  templateUrl: './manual-reservation.component.html',
  styleUrls: ['./manual-reservation.component.css'],
  standalone: false,
})
export class ManualReservationComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly selectReservationDialogLink: string = AppConst.ROUTING_LINK_MANUAL_SELECT_RESERVATION_DIALOG;
  readonly manualConfirmReservsationDialogLink: string = AppConst.ROUTING_LINK_MANUAL_CONFIRM_RESERVATION_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
